/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePomShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="M6.89 17v-4.87h1.742c.599 0 1.05.138 1.354.415.308.277.462.688.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.416-1.354.416H7.93V17zm1.528-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.18-.757-.18zm4.783 4.114c-.728 0-1.29-.219-1.688-.657-.393-.442-.59-1.067-.59-1.876 0-.8.2-1.42.597-1.862.397-.442.958-.664 1.681-.664s1.285.222 1.682.664c.398.442.596 1.063.596 1.862 0 .809-.196 1.434-.59 1.876-.392.438-.955.657-1.688.657zm0-.891c.407 0 .708-.14.905-.422.201-.282.301-.688.301-1.22s-.1-.936-.301-1.212c-.197-.282-.498-.423-.904-.423-.407 0-.71.141-.912.423-.196.276-.295.68-.295 1.212s.099.938.295 1.22c.201.281.505.422.911.422zm3.066.797v-4.87h1.092l1.547 3.208 1.528-3.209h1.092V17h-1.032v-3.156l-1.286 2.687h-.643l-1.287-2.646V17zm-13.793.474L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePomShortcut as FilePomShortcut };
